import { BasePropertyDTO, IDispensingRobotDTO } from 'business/models/Models';
import { PropertyDiscriminator } from 'enums/DispensingPropertiesConstants';
import { IGeneralDispensingPropertiesData } from './constants';
import PropertyView from './PropertyView';
import React from 'react';

export const setPropertyValue = (property: BasePropertyDTO, e: any) => {
  switch (property['discriminator']) {
    case PropertyDiscriminator.ListEnumDTO:
      const val = property['options'].find((opt) => opt.id === parseInt(e.target.value));
      property['value'] = val;
      break;
    case PropertyDiscriminator.DBListPropertyDTO:
    case PropertyDiscriminator.ListPropertyDTO:
      property['value'] = property['options'].find((opt) => opt.name === e.target.value);
      break;
    case PropertyDiscriminator.ColorPropertyDTO:
      property['value'] = e;
      break;
    case PropertyDiscriminator.IntPropertyDTO:
    case PropertyDiscriminator.LongPropertyDTO:
      property['value'] = parseInt(e.target.value);
      break;
    case PropertyDiscriminator.DoublePropertyDTO:
    case PropertyDiscriminator.FloatPropertyDTO:
      property['value'] = e.target.value;
      break;
    case PropertyDiscriminator.StringPropertyDTO:
      property['value'] = e.target.value;
      break;
    case PropertyDiscriminator.BooleanPropertyDTO:
      property['value'] = e;
      break;
    default:
    // handle any other cases here
  }
};

export const liquidClassColumnsData = (handleTableFilter: any): any => {
  return [
    {
      accessor: 'liquidClass',
      Header: 'Liquid Class',
      Filter: handleTableFilter(false, 'Liquid Class'),
    },
    {
      accessor: 'liquidClassName',
      Header: 'Liquid Class Name',
    },
  ];
};

export const plateColumnsData = (handleTableFilter: any): any => {
  return [
    {
      accessor: 'plateType',
      Header: 'Plate Type',
      Filter: handleTableFilter(false, 'Plate Type'),
    },
    {
      accessor: 'plateDefinitionName',
      Header: 'Plate Definition Name',
    },
  ];
};

export const platePropertiesData = (
  data: IGeneralDispensingPropertiesData,
  robot: IDispensingRobotDTO,
  onChangeProp: any,
): any => {
  return Object.keys(data.plateProperties[robot.id]).map((key) => {
    const plateType = data.plates.find((plate) => plate.id == parseInt(key)).name;
    const plateDefinitionName = data.plateProperties[robot.id][parseInt(key)].map(
      (property, index) => (
        <PropertyView
          key={robot.name + key + '-' + index}
          property={property}
          onChangeProp={onChangeProp}
          robotId={robot.id}
          plateId={parseInt(key)}
          liquidClassId={null}
        />
      ),
    );
    return {
      plateType: plateType,
      plateDefinitionName: plateDefinitionName,
    };
  });
};

export const liquidClassPropertiesData = (
  data: IGeneralDispensingPropertiesData,
  robot: IDispensingRobotDTO,
  onChangeProp: any,
): any => {
  return Object.keys(data.liquidClassProperties[robot.id]).map((key) => {
    const LiquidClass = data.liquidClasses.find(
      (liquidClass) => liquidClass.id == parseInt(key),
    ).name;
    const liquidClassName = data.liquidClassProperties[robot.id][parseInt(key)].map(
      (property, index) => (
        <PropertyView
          key={robot.name + key + '-' + index}
          property={property}
          onChangeProp={onChangeProp}
          robotId={robot.id}
          plateId={null}
          liquidClassId={parseInt(key)}
        />
      ),
    );
    return {
      liquidClass: LiquidClass,
      liquidClassName: liquidClassName,
    };
  });
};
